import { render, staticRenderFns } from "./GetAQuoteSecond.vue?vue&type=template&id=106d5395&scoped=true&"
import script from "./GetAQuoteSecond.vue?vue&type=script&lang=js&"
export * from "./GetAQuoteSecond.vue?vue&type=script&lang=js&"
import style0 from "./GetAQuoteSecond.vue?vue&type=style&index=0&id=106d5395&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d5395",
  null
  
)

export default component.exports